<template>
  <div>
    <h3 class="mb-2">{{ prenomNom }}</h3>
    <address class="mb-6">
      {{ account.adresse.adresse }}<br />
      {{ account.adresse.ville }},
      {{ account.adresse.province[$i18n.locale] }}
      {{ account.adresse.codePostal }}<br />
    </address>
    <div class="text-center">
      <v-btn color="primary" @click="logout" text large>{{ $t("formulaireAuth.seDeconnecter") }}</v-btn>
    </div>
  </div>
</template>

<script>
import Auth from "@/mixins/Auth"

export default {
  mixins: [Auth]
}
</script>

<style>
</style>